import {
    URLAPI,
    USER_TYPES_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_user_types: {
        data: [],
        status: 0,
        message: {},
    },
};

const GET_ALL_USER_TYPES = "GET_ALL_USER_TYPES";

export const user_types_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_USER_TYPES:
            return {
                ...state,
                _get_all_user_types: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllUserTypes = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${USER_TYPES_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_USER_TYPES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_USER_TYPES,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_USER_TYPES,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};
